/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис предоставляет возможность действий с пользователями
 */

/**
 * Сервис действий с пользователями
 */
export class UserServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод переноса кабинета ключа в другой кабинет SSO.
   * Метод доступен для: admin, service, ltp_first
   */
  PostUserSsoMigration = (req: PostUserSsoMigrationRequestDto, init?: RequestInit): Promise<PostUserSsoMigrationResponseDto> => {
    return fm.request<PostUserSsoMigrationRequestDto, PostUserSsoMigrationResponseDto>(`${this.host}/identity/api/v1/user/sso_migration`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос на перенос кабинета ключа
 */
export type PostUserSsoMigrationRequestDto = {
  /**
   * Идентификатор мигрируемого пользователя.
   * # Диапазон: 1..2147483647
   */
  userId: number
  /**
   * Целевой номер телефона.
   * # Диапазон: 5..14
   */
  phoneNumber: string
}
/**
 * Ответ на запрос на перенос кабинета ключа
 */
export type PostUserSsoMigrationResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PostUserSsoMigrationResponseErrorDto
}>
/**
 * Ошибка запроса на перенос кабинета ключа
 */
export type PostUserSsoMigrationResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
  /**
   * Номер уже используется. Укажите другой номер
   */
  readonly userExists: PostUserSsoMigrationResponseErrorUserExistsRequestDto
}>
/**
 * Ошибка запроса на перенос кабинета ключа
 */
export type PostUserSsoMigrationResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
  /**
   * Номер уже используется. Укажите другой номер
   */
  readonly userExists: PostUserSsoMigrationResponseErrorUserExistsDto
}>
/**
 * Номер уже используется. Укажите другой номер
 */
export type PostUserSsoMigrationResponseErrorUserExistsRequestDto = {
}
/**
 * Номер уже используется. Укажите другой номер
 */
export type PostUserSsoMigrationResponseErrorUserExistsDto = {
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос на перенос кабинета ключа
   */
  "PostUserSsoMigrationRequest": {
    "kind": "class",
    "text": "Запрос на перенос кабинета ключа",
    "fields": {
      /**
       * Идентификатор мигрируемого пользователя.
       * # Диапазон: 1..2147483647
       */
      "userId": {
        "type": "int32",
        "text": "Идентификатор мигрируемого пользователя.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Целевой номер телефона.
       * # Диапазон: 5..14
       */
      "phoneNumber": {
        "type": "string",
        "text": "Целевой номер телефона.\n# Диапазон: 5..14",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 5,
            "message": "Значение не входит в допустимый диапазон. Минимум: 5"
          },
          "maxLength": {
            "value": 14,
            "message": "Значение не входит в допустимый диапазон. Максимум: 14"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос на перенос кабинета ключа
   */
  "PostUserSsoMigrationResponse": {
    "kind": "class",
    "text": "Ответ на запрос на перенос кабинета ключа",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PostUserSsoMigrationResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса на перенос кабинета ключа
   */
  "PostUserSsoMigrationResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса на перенос кабинета ключа",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Номер уже используется. Укажите другой номер
       */
      "userExists": {
        "type": "PostUserSsoMigrationResponse.Error.UserExists",
        "text": "Номер уже используется. Укажите другой номер",
      },
    },
  },
  /**
   * Номер уже используется. Укажите другой номер
   */
  "PostUserSsoMigrationResponse.Error.UserExists": {
    "kind": "class",
    "text": "Номер уже используется. Укажите другой номер",
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}